// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopularItem_wrapper__myNJH","image":"PopularItem_image__1al2-","title":"PopularItem_title__2h9Xl","date":"PopularItem_date__JxjVz"};